import { IncomingHttpHeaders } from 'http';
import { apiClient } from '@doda/api-client/util/apiClient';
import { Methods as NearAreaAPI } from '@doda/api-client/aspida/api/v1/jobs/neararea';

export type NearAreaQuery = NonNullable<NearAreaAPI['get']['query']>;
export const NEAR_AREA_DISPLAY_NUMBER = 5;

/**
 * 近隣エリアAPIへのリクエスト
 * @param {NearAreaQuery} query
 * @param {IncomingHttpHeaders} headers
 * @return {NearAreaResponse} 保存した検索条件一覧
 */
export const getNearAreaJobList = (
  query: NearAreaQuery,
  headers?: IncomingHttpHeaders
) => {
  return apiClient.api.v1.jobs.neararea.$get({
    query,
    config: { headers },
  });
};
